define([
  'backbone-ex',
  'darsan',
], function(Backbone, darsan){
  
  darsan.injectToBackbone(Backbone);

  return Backbone;
});